import {
	Component,
	OnInit
}                                from '@angular/core';
import { BaseComponent }         from '@app/core/bases/base-component/base.component';
import { DialogModalCommonType } from '@app/core/models/dialog-modal-common-type.enum';
import { NgbActiveModal }        from '@ng-bootstrap/ng-bootstrap';

@Component( {
	selector: 'app-dialog-modal-common',
	templateUrl: './dialog-modal-common.component.html',
	styleUrls: [ './dialog-modal-common.component.scss' ]
} )
export class DialogModalCommonComponent extends BaseComponent implements OnInit {

	cancelButtonBaseI18nPath: string;
	cancelType = 'cancel';
	confirmButtonBaseI18nPath: string;
	confirmType = 'confirm';
	description: string;
	isConfirm: boolean;
	isError: boolean;
	isInfo: boolean;
	isStandard: boolean;
	isSuccess: boolean;
	isWarning: boolean;
	message: any;
	replaceTextPlaceholders: { [ key: string ]: any };
	showHeader: boolean;
	title: string;
	type: DialogModalCommonType;

	constructor( public activeModal: NgbActiveModal ) {
		super();
		this.translationPath = 'DialogCommon';
	}

	ngOnInit() {
		this.isConfirm = this.type === DialogModalCommonType.QUESTION;
		this.isError = this.type === DialogModalCommonType.ERROR;
		this.isInfo = this.type === DialogModalCommonType.INFO;
		this.isSuccess = this.type === DialogModalCommonType.SUCCESS;
		this.isWarning = this.type === DialogModalCommonType.WARNING;
		this.isStandard = this.type === DialogModalCommonType.STANDARD;

		this.showHeader = this.isError || this.isSuccess || this.isWarning || this.isInfo || this.isStandard;
	}

	modalAbort() {
		this.activeModal.close( 'abort' );
	}

	modalClose() {
		this.activeModal.close( 'close' );
	}

	modalConfirm() {
		this.activeModal.close( this.confirmType );
	}
}
